import { apiRequest } from "./apiClient";
import { stateChangingRequest } from "./authApi";

export function getSessionSettings() {
  return apiRequest("/api/session-management/settings");
}

export function updateSessionSettings(timeoutSeconds) {
  return stateChangingRequest("/api/session-management/settings", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ timeoutSeconds }),
  });
}

export function invalidateNonRootSessions() {
  return stateChangingRequest("/api/session-management/invalidate", {
    method: "POST",
  });
}

export function invalidateUserSessions(userId) {
  return stateChangingRequest(
    `/api/session-management/users/${encodeURIComponent(userId)}/invalidate`,
    {
      method: "POST",
    },
  );
}
